export default {
  leagues: {
    title: "Seleccionar liga",
    empty: {
      favoriteLeagues: "Marca tus ligas favoritas para fijarlas arriba y acceder más rápido",
    },
    actions: {
      starFavoriteLeagues: "Marcar ligas favoritas",
    },
    status: {
      live: "Activo",
      offseason: "Fuera de temporada",
    },
    sections: {
      myLeagues: "Mis ligas",
      sports: {
        baseball: "Béisbol",
        basketball: "Baloncesto",
        football: "Fútbol americano",
        "australian-football": "Fútbol australiano",
        rugby: "Rugby",
        hockey: "Hockey",
        soccer: "Fútbol",
      },
    },
  },
};
